// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-input[data-v-c6337260]{padding:var(--spacing-1);flex:0 0 320px;border:2px solid var(--primary);text-align:right;border-radius:0;outline:none;max-width:320px;color:var(--black)}", ""]);
// Exports
module.exports = exports;
